import { ChangeDetectorRef, type OnDestroy, Pipe, type PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { type Subscription } from 'rxjs';

@Pipe({
  name: 'statusDisplayName',
  pure: false
})
export class StatusDisplayNamePipe implements PipeTransform, OnDestroy {
  private translate = inject(TranslateService);

  private lang: string;
  private subscription: Subscription;

  constructor(private cdr: ChangeDetectorRef) {
    this.lang = this.translate.currentLang;
    this.subscription = this.translate.onLangChange.subscribe(e => {
      this.lang = e.lang;
      this.cdr.markForCheck();
    });
  }

  transform(item: { displayNames?: Record<string, string>; name?: string } | null | undefined): string {
    // console.log('statusDisplayName pipe called with item:', item);
    if (!item) {
      return '';
    }
    const displayName = item.displayNames?.[this.lang]?.trim();
    const fallback = typeof item.name === 'string' && item.name.trim() !== '' ? this.translate.instant(item.name) : '';

    return displayName || fallback;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe(); // clean up
  }
}
